import { createApiEffect } from '@/features/api/common/create-api-effect'
import { AdmissionStepsType } from '@/features/api/student/types'

export const getStepsListFx = createApiEffect<void, AdmissionStepsType[]>({
  requestMapper: () => ({
    method: 'GET',
    url: '/api/ticket-app/admission/filter/step-numbers/',
  }),
})
